/**
 * Base icon SVG component
 * Standard Base logo
 */
export function BaseIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 2500 2500"
      fill="none"
      className={className}
    >
      <g id="Layer_x0020_1">
        <path
          d="M1247.8,2500c691.6,0,1252.2-559.6,1252.2-1250C2500,559.6,1939.4,0,1247.8,0C591.7,0,53.5,503.8,0,1144.9h1655.1v210.2H0   C53.5,1996.2,591.7,2500,1247.8,2500z"
          fill="black"
        />
      </g>
    </svg>
  );
}
